import { NgModule } from '@angular/core';
import { TranslateModule } from '@xref/ngx';

import { OauthLinkedInComponent } from './oauth-linkedin.component';

@NgModule({
    imports: [
        TranslateModule
    ],
    declarations: [OauthLinkedInComponent]
})
export class OauthLinkedInModule {}
